var _path, _path2, _path3, _path4, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeleteButton = function SvgDeleteButton(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89124 4.15L9.97714 11.3374C9.98972 12.39 9.13993 13.25 8.08728 13.25H2.91272C1.86007 13.25 1.01028 12.39 1.02286 11.3374L1.10876 4.15",
    fill: "#D52331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89124 4.15L9.97714 11.3374C9.98972 12.39 9.13993 13.25 8.08728 13.25H2.91272C1.86007 13.25 1.01028 12.39 1.02286 11.3374L1.10876 4.15L9.89124 4.15Z",
    stroke: "#D52331",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.2H10",
    stroke: "#D52331",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39999 0.65H7.74999",
    stroke: "#D52331",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 1,
    height: 7,
    rx: 0.5,
    fill: "#D52331"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 1,
    height: 7,
    rx: 0.5,
    fill: "#D52331"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 1,
    height: 7,
    rx: 0.5,
    fill: "#D52331"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete_button.e7b718bf9b29d2a57ea1f17d22308c5c.svg";